import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The single sanctioned class-merger (design.md §11). `clsx` builds the list,
 * `twMerge` resolves conflicting Tailwind utilities so later wins.
 *
 * Call signature MUST be `cn(variants({ variant, size }), className)` — the
 * caller `className` last so consumers can override.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
